import { Page, Card, Link, Banner, Text, Box, BlockStack } from '@shopify/polaris';
import { useAuthStore } from '../../context/useStore.js';
import userRoles from '../../utils/userRoles.js';
import HolidayRequestsComponent from '../holidays/components/holidayrequests.jsx';
import { CardHeading } from '../../shared/components/cards/CardHeading.jsx';
import ApprovalsHomeCard from './approvalsHomeCard.jsx';
import DeliveryAlertsHomeCard from './deliveryAlertsHomeCard.jsx';
import SignatureBannerNotice from './signatureBannerNotice.jsx';

export default function HomePage() {
  const { user } = useAuthStore();

  const OrgOverview = () => {
    const comp =
      user?.role === userRoles.AdminFull || user?.role === userRoles.AdminData ? (
        <Box paddingBlockEnd="300">
          <Card>
            <CardHeading title="List of Admin applications" />
            <BlockStack>
              <div>
                Schuilenburg NV:{' '}
                <Link removeUnderline url="https://admin.schuilenburg.be">
                  admin.schuilenburg.be
                </Link>
              </div>
              <div>
                Aha innovations:{' '}
                <Link removeUnderline url="https://adminaha.schuilenburg.be">
                  adminaha.schuilenburg.be
                </Link>
              </div>
              <div>
                Adriaens NV:{' '}
                <Link removeUnderline url="https://adminadriaens.schuilenburg.be">
                  adminadriaens.schuilenburg.be
                </Link>
              </div>
              <div>
                Jadibo NV:{' '}
                <Link removeUnderline url="https://adminjadibo.schuilenburg.be">
                  adminjadibo.schuilenburg.be
                </Link>
              </div>
              <div>
                Perfect moose NY:{' '}
                <Link removeUnderline url="https://admin.perfectmoose.com">
                  admin.perfectmoose.com
                </Link>
              </div>
            </BlockStack>
          </Card>
        </Box>
      ) : null;
    return comp;
  };

  return (
    <Page title={`Welcome home, ${user?.username}`} fullWidth>
      <SignatureBannerNotice />

      <OrgOverview />

      {/* incoming invoice / credit note approvals now live in the approval queue (/approvals) */}
      <ApprovalsHomeCard />

      <DeliveryAlertsHomeCard />

      {user?.role === userRoles.AdminFull ? <HolidayRequestsComponent /> : null}

      <Box paddingBlockEnd="400">
        <Banner
          title={
            <Text>
              Organising a fair? Easily collect company and contact information by using the <Link url={'/fairs'}>fairs app</Link>.
            </Text>
          }
        />
      </Box>
    </Page>
  );
}
